import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ size = "md", onClick }) => {
  const dim = size === "lg" ? "h-10 w-10" : size === "sm" ? "h-7 w-7" : "h-9 w-9";
  const text = size === "lg" ? "text-2xl" : "text-xl";
  return (
    <Link to="/" onClick={onClick} className="flex items-center gap-2.5 group" data-testid="vw-logo">
      <span className={`${dim} relative grid place-items-center rounded-xl`}
        style={{ background: "linear-gradient(135deg,#00FF66,#10B981)" }}>
        <svg viewBox="0 0 24 24" className="h-[60%] w-[60%]" fill="none" stroke="#04210F" strokeWidth="2.4">
          <path d="M3 12l5 7 5-14 4 10 4-5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      <span className={`font-display font-extrabold tracking-tight ${text} text-white`}>
        Virtual<span style={{ color: "#00FF66" }}>Win</span>
      </span>
    </Link>
  );
};
